/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ResetPassword model module.
 * @module model/ResetPassword
 * @version v1
 */
class ResetPassword {
    /**
     * Constructs a new <code>ResetPassword</code>.
     * @alias module:model/ResetPassword
     * @param uniqueIdentifier {String} MaxLength:100
     * @param newPassword {String} MaxLength:64
     * @param confirmNewPassword {String} MaxLength:64
     */
    constructor(uniqueIdentifier, newPassword, confirmNewPassword) { 
        
        ResetPassword.initialize(this, uniqueIdentifier, newPassword, confirmNewPassword);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, uniqueIdentifier, newPassword, confirmNewPassword) { 
        obj['UniqueIdentifier'] = uniqueIdentifier;
        obj['NewPassword'] = newPassword;
        obj['ConfirmNewPassword'] = confirmNewPassword;
    }

    /**
     * Constructs a <code>ResetPassword</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ResetPassword} obj Optional instance to populate.
     * @return {module:model/ResetPassword} The populated <code>ResetPassword</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ResetPassword();

            if (data.hasOwnProperty('UniqueIdentifier')) {
                obj['UniqueIdentifier'] = ApiClient.convertToType(data['UniqueIdentifier'], 'String');
            }
            if (data.hasOwnProperty('NewPassword')) {
                obj['NewPassword'] = ApiClient.convertToType(data['NewPassword'], 'String');
            }
            if (data.hasOwnProperty('ConfirmNewPassword')) {
                obj['ConfirmNewPassword'] = ApiClient.convertToType(data['ConfirmNewPassword'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ResetPassword</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ResetPassword</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ResetPassword.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['UniqueIdentifier'] && !(typeof data['UniqueIdentifier'] === 'string' || data['UniqueIdentifier'] instanceof String)) {
            throw new Error("Expected the field `UniqueIdentifier` to be a primitive type in the JSON string but got " + data['UniqueIdentifier']);
        }
        // ensure the json data is a string
        if (data['NewPassword'] && !(typeof data['NewPassword'] === 'string' || data['NewPassword'] instanceof String)) {
            throw new Error("Expected the field `NewPassword` to be a primitive type in the JSON string but got " + data['NewPassword']);
        }
        // ensure the json data is a string
        if (data['ConfirmNewPassword'] && !(typeof data['ConfirmNewPassword'] === 'string' || data['ConfirmNewPassword'] instanceof String)) {
            throw new Error("Expected the field `ConfirmNewPassword` to be a primitive type in the JSON string but got " + data['ConfirmNewPassword']);
        }

        return true;
    }


}

ResetPassword.RequiredProperties = ["UniqueIdentifier", "NewPassword", "ConfirmNewPassword"];

/**
 * MaxLength:100
 * @member {String} UniqueIdentifier
 */
ResetPassword.prototype['UniqueIdentifier'] = undefined;

/**
 * MaxLength:64
 * @member {String} NewPassword
 */
ResetPassword.prototype['NewPassword'] = undefined;

/**
 * MaxLength:64
 * @member {String} ConfirmNewPassword
 */
ResetPassword.prototype['ConfirmNewPassword'] = undefined;






export default ResetPassword;

